var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('Header',{attrs:{"headertext":"About"}}),_c('h2',[_vm._v("コンタクト")]),_c('a',{attrs:{"href":"mailto:ambiesoft.trueff@gmail.com"}},[_vm._v("e-mail")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }